/**
 * @packageDocumentation
 * @module api.functional.auth.resend_email_verification
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

/**
 * @controller AuthController.resendEmailVerification
 * @path POST /auth/resend-email-verification
 * @accessor api.functional.auth.resend_email_verification.resendEmailVerification
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function resendEmailVerification(
  connection: IConnection,
): Promise<resendEmailVerification.Output> {
  return PlainFetcher.fetch(connection, {
    ...resendEmailVerification.METADATA,
    template: resendEmailVerification.METADATA.path,
    path: resendEmailVerification.path(),
  });
}
export namespace resendEmailVerification {
  export type Output =
    | {
        success: boolean;
        nextResendAt: string;
      }
    | {
        success: boolean;
        nextResendAt: null;
      };

  export const METADATA = {
    method: "POST",
    path: "/auth/resend-email-verification",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/auth/resend-email-verification";
}
